import {IPageData} from 'coreClasses/events/IEvents';
import {useUI} from 'coreHooks';
import useHandlePageEventsBase from 'coreHooks/useHandlePageEvents';

export const useHandlePageEvents = (pageData: IPageData, pageDependencies: any[]) => {
	const pageViewCounter = useUI('pageViewCounter');

	return useHandlePageEventsBase(pageData, pageDependencies, null, pageViewCounter);
};
